// Files of the DMS app (apps/dms/src/assets/fonts). The PDF service cannot load them from the
// app, so the document carries them as data URLs.
const DOCUMENT_FONT_FACES = [
  {weight: 400, file: '/assets/fonts/inter-regular.woff2'},
  {weight: 700, file: '/assets/fonts/inter-bold.woff2'},
];

async function readAsDataUrl(file: string) {
  try {
    const response = await fetch(file);
    if (!response.ok) {
      return undefined;
    }
    const blob = await response.blob();
    return await new Promise<string | undefined>((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : undefined);
      reader.onerror = () => resolve(undefined);
      reader.readAsDataURL(blob);
    });
  } catch {
    return undefined;
  }
}

/**
 * Embeds the Inter font of the DMS app into a print document. A font that cannot be loaded is
 * left out, and the document falls back to the next font of its font stack.
 */
export async function embedDocumentFonts(html: string) {
  const faces = await Promise.all(
    DOCUMENT_FONT_FACES.map(async (face) => ({...face, url: await readAsDataUrl(face.file)}))
  );
  const rules = faces
    .filter((face) => face.url !== undefined)
    .map(
      (face) =>
        `@font-face { font-family: 'Inter'; font-style: normal; font-weight: ${face.weight}; src: url('${face.url}') format('woff2'); }`
    )
    .join('\n');
  return rules === '' ? html : html.replace('<head>', `<head><style>${rules}</style>`);
}
